module.exports = __webpack_public_path__ + "4dc733c5440d0764dbc69b63f90a6701.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/home/components/images/lemon.png
 ** module id = 1570
 ** module chunks = 0
 **/